import { render, staticRenderFns } from "./BoasPraticasPorIndicador.vue?vue&type=template&id=05324e37&scoped=true"
import script from "./BoasPraticasPorIndicador.vue?vue&type=script&lang=js"
export * from "./BoasPraticasPorIndicador.vue?vue&type=script&lang=js"
import style0 from "./BoasPraticasPorIndicador.vue?vue&type=style&index=0&id=05324e37&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05324e37",
  null
  
)

export default component.exports